import React, { FC, useCallback, useMemo } from 'react';
import {
  IStudentBookBag,
  IStudentBookBagBookmark,
  IStudentBookBagLastViewdTrajectory,
} from '../../../../config/api/models/Book';
import { useI18nPath } from '../../../../config/clientRoutes/hooks';
import UnfinishedTrajectoriesList from './UnfinishedTrajectoriesList';
import { useHistory } from 'react-router-dom';
import {
  BookCover,
  BookTrajectoriesWrapper,
  StyledBookCoverImageLink,
  Trajectories,
  Wrapper,
} from './Atoms';
import { Feedback } from '../../../../config/api/models/Feedback';
import BookWithUnfinishedTrajectoriesHeader from './BookWithUnfinishedTrajectoriesHeader';
import BookmarkTrajectoriesList from './BookmarkTrajectoriesList';

type Props = {
  book: IStudentBookBag;
  lastViewedTrajectory?: IStudentBookBagLastViewdTrajectory;
  bookmark?: IStudentBookBagBookmark[];
  studentFeedback?: Feedback[];
  id?: string;
};

const BookWithUnfinishedTrajectories: FC<Props> = ({
  book,
  lastViewedTrajectory,
  bookmark,
  studentFeedback,
  id,
}) => {
  const { getPath } = useI18nPath();
  const history = useHistory();

  const hasUnreadFeedbackInBook = useMemo(() => {
    if (studentFeedback == null) return false;

    return studentFeedback.flatMap((item) => item.students).some((item) => !item.isRead);
  }, [studentFeedback]);

  const handleFeedbackClick = useCallback(
    () => history.push(getPath('bookOverview', { bookId: book.id })),
    [history, getPath, book.id]
  );

  return (
    <Wrapper id={id}>
      <BookWithUnfinishedTrajectoriesHeader
        linkPath={getPath('bookOverview', { bookId: book.id })}
        title={book.title}
        hasUnreadFeedbackInBook={hasUnreadFeedbackInBook}
        handleFeedbackClick={handleFeedbackClick}
      />

      <BookTrajectoriesWrapper>
        <BookCover>
          <StyledBookCoverImageLink
            image={book.coverImage}
            to={getPath('bookOverview', { bookId: book.id })}
          />
        </BookCover>
        <Trajectories>
          <UnfinishedTrajectoriesList
            bookId={book.id}
            lastViewedTrajectory={lastViewedTrajectory}
          />
          <BookmarkTrajectoriesList bookmark={bookmark} />
        </Trajectories>
      </BookTrajectoriesWrapper>
    </Wrapper>
  );
};

export default BookWithUnfinishedTrajectories;
